import { Dialog, DialogTitle, DialogContent, IconButton, Grid, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { columns } from './grid-columns';
import { contractApiKeyStore } from '../../api/contract-api-key-store';
import { UserPermissionName } from '../../models/user-permission-name';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface ContractsDialogProps {
  officeID: number;
  open: boolean;
  onClose: () => void;
}

export const ContractsListDialog = ({ officeID, open, onClose }: ContractsDialogProps) => {
  const handleDialogClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={handleDialogClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        CONTRACTS
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog">
        <Grid>
          <SiTrackGrid
            fileTitle='contact'
            dataItemKey="contractID"
            columns={columns}
            queryConfig={contractApiKeyStore.getOfficeContracts(Number(officeID))}
            actionPermissions={{
              export: UserPermissionName.DOWNLOAD_GRID,
            }}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
